import { gql } from "@apollo/client";

export const PRODUCT_IDS_QUERY = gql`
  query product($categoryIds: [Identifier!]!) {
    product(categoryIds: $categoryIds) {
      data {
        id
        name
      }
    }
  }
`;
